import { CAMPAING_PROMISE_TYPES } from '../../../../constants/enums';

export const PROMISE_TYPE_FIELDS = {
    // Danish fields
    [CAMPAING_PROMISE_TYPES.DK_AIRPORT_VAC]: ['PO number'],
    [CAMPAING_PROMISE_TYPES.DK_AIRPORT_VAC_PANELS]: ['Promise Screens', 'Delivered Screens', 'PO number'],
    [CAMPAING_PROMISE_TYPES.DK_CLASSIC_PANELS]: ['Promise Screens', 'Delivered Screens', 'PO number'],
    [CAMPAING_PROMISE_TYPES.DK_PLAY_PLAYS]: ['Promised Plays', 'Delivered Plays', 'PO number'],
    [CAMPAING_PROMISE_TYPES.DK_PLAY_VAC]: ['Delivered VAC', 'PO number'],
    [CAMPAING_PROMISE_TYPES.DK_PLAY_VAC_PANELS]: [
        'Delivered VAC', 'Promise Screens', 'Delivered Screens', 'PO number'
    ],

    // Norwegian fields
    [CAMPAING_PROMISE_TYPES.NO_PLAY_SOV_2_0]: [
        'Estimated VAC', 'Delivered VAC/VI', 'VAC/VI over delivery', 'Delivered Alternative VAC/VI',
        'Delivered Plays', 'Estimated Panels', 'Delivered Panels', 'Estimated Spot length',
        'Delivered Spot length', 'Estimated SOV', 'Delivered SOV'
    ],    
    [CAMPAING_PROMISE_TYPES.NO_CLASSIC_PANELS]: ['Estimated VAC', 'Delivered Panels'],
    [CAMPAING_PROMISE_TYPES.NO_CLASSIC_PANELS_FILLER]: ['Delivered Panels'],
    [CAMPAING_PROMISE_TYPES.NO_PLAY_PLAYS]: [
        'Estimated SOV', 'Delivered Panels', 'Estimated Plays', 'Delivered Plays',
        'Plays over delivery'
    ],
    [CAMPAING_PROMISE_TYPES.NO_PLAY_VAC]: [
        'Estimated VAC', 'Delivered VAC/VI', 'VAC/VI over delivery', 'Delivered Alternative VAC/VI', 
        'Delivered Panels', 'Estimated SOV', 'Estimated Plays', 'Delivered Plays', 
        'Plays over delivery'
    ],
    [CAMPAING_PROMISE_TYPES.NO_PLAY_VAC_FILLER]: [
        'Estimated VAC', 'Delivered VAC/VI', 'VAC/VI over delivery', 'Delivered Alternative VAC/VI', 
        'Delivered Panels', 'Delivered Plays'
    ],
    [CAMPAING_PROMISE_TYPES.NO_CLASSIC_VAC_2_0]: [
        'Estimated VAC', 'Delivered VAC/VI', 'Delivered Panels', 'Delivered Reach %', 'Delivered Reach', 'Delivered Frequency'
    ],
    [CAMPAING_PROMISE_TYPES.NO_CLASSIC_PANELS_2_0]: ['Estimated Panels', 'Delivered Panels'],
    [CAMPAING_PROMISE_TYPES.NO_CLASSIC_PANELS_VAC_2_0]: ['Delivered VAC/VI', 'Estimated Panels', 'Delivered Panels'],
    [CAMPAING_PROMISE_TYPES.NO_CLASSIC_VAC_FILLER_2_0]: ['Estimated VAC/VI', 'Delivered VAC/VI', 'Delivered Panels'],
    [CAMPAING_PROMISE_TYPES.NO_PLAY_VAC_2_0]: [
        'Estimated VAC/VI', 'Delivered VAC/VI', 'VAC/VI over delivery', 'Delivered Alternative VAC/VI', 
        'Estimated Panels', 'Delivered Panels', 'Estimated Spot length', 'Delivered Plays', 'Delivered SOV',
        'Delivered Spot length', 'Delivered Reach %', 'Delivered Reach', 'Delivered Frequency'
    ],
    [CAMPAING_PROMISE_TYPES.NO_PLAY_VAC_FILLER_2_0]: [
        'Estimated VAC/VI', 'Delivered VAC/VI', 'VAC/VI over delivery', 'Delivered Alternative VAC/VI', 
        'Estimated Panels', 'Delivered Panels', 'Estimated Spot length', 'Delivered Spot length', 'Delivered Plays', 'Delivered SOV'
    ],
    [CAMPAING_PROMISE_TYPES.NO_PLAY_PLAYS_2_0]: [
        'Estimated SOV', 'Delivered SOV', 'Estimated Panels', 'Delivered Panels',  
        'Estimated Plays', 'Delivered Plays', 'Plays over delivery', 'Estimated Spot length', 'Delivered Spot length'
    ],
    [CAMPAING_PROMISE_TYPES.NO_AIRPORT_PLAYS_2_0_1]: [
        'Estimated SOV', 'Delivered SOV', 'Estimated Panels', 'Delivered Panels',  
        'Estimated Plays', 'Delivered Plays', 'Plays over delivery', 'Estimated Spot length', 'Delivered Spot length'
    ],

    // Swedish fields
    [CAMPAING_PROMISE_TYPES.SE_CLASSIC_PANELS_EAVAC_OI]: [
        'Estimated EA-VAC', 'Delivered EA-VAC', 'Estimated Panels', 'Delivered Panels'
    ],    
    [CAMPAING_PROMISE_TYPES.SE_CLASSIC_EAVAC]: [
        'Estimated EA-VAC', 'Delivered EA-VAC', 'Estimated Panels', 'Delivered Panels', 
        'Delivered No.of panels in IDS'
    ],
    [CAMPAING_PROMISE_TYPES.SE_CLASSIC_PANELS]: [
        'Estimated Panels', 'Delivered Panels'
    ],
    [CAMPAING_PROMISE_TYPES.SE_CLASSIC_PANELS_FILLER]: [
        'Estimated Panels', 'Delivered Panels'
    ],
    [CAMPAING_PROMISE_TYPES.SE_CLASSIC_PANELS_OI]: [
        'Estimated EA-VAC', 'Delivered EA-VAC', 'Estimated Panels', 'Delivered Panels', 
        'Delivered No.of panels in IDS'
    ],
    [CAMPAING_PROMISE_TYPES.SE_DIGITAL_EAVAC]: [
        'Estimated EA-VAC', 'Delivered EA-VAC', 'Delivered Alternative VAC',
        'Estimated Plays', 'Delivered Plays', 'Estimated SOV', 'Delivered SOV',
        'Estimated Panels', 'Delivered Panels', 'Estimated Spot length', 'Delivered Spot length'
    ],
    [CAMPAING_PROMISE_TYPES.SE_DIGITAL_EAVAC_FILLER]: [
        'Estimated EA-VAC', 'Delivered EA-VAC', 'Delivered Alternative VAC',
        'Delivered Plays', 'Delivered SOV', 'Estimated Panels', 'Delivered Panels',
        'Estimated Spot length', 'Delivered Spot length'
    ],
    [CAMPAING_PROMISE_TYPES.SE_DIGITAL_PLAYS]: [
        'Delivered EA-VAC', 'Delivered Alternative VAC', 'Estimated Plays',
        'Delivered Plays', 'Estimated SOV', 'Delivered SOV', 'Estimated Panels',
        'Delivered Panels', 'Estimated Spot length', 'Delivered Spot length'
    ],
    [CAMPAING_PROMISE_TYPES.SE_DIGITAL_NO_PROMISE]: [
        'Delivered EA-VAC', 'Delivered Alternative VAC', 'Delivered Plays',
        'Delivered SOV', 'Delivered Panels', 'Delivered Spot length'
    ],
    [CAMPAING_PROMISE_TYPES.SE_DIGITAL_SOV]: [
        'Estimated EA-VAC', 'Delivered EA-VAC', 'Delivered Alternative VAC',
        'Estimated Plays', 'Delivered Plays', 'Estimated SOV', 'Delivered SOV',
        'Estimated Panels', 'Delivered Panels', 'Estimated Spot length',
        'Delivered Spot length', 'Delivered No.of panels in IDS'
    ],
    [CAMPAING_PROMISE_TYPES.SE_DIGITAL_VAC]: [
        'Estimated Plays', 'Delivered Plays', 'Estimated SOV', 'Delivered SOV',
        'Estimated Panels', 'Delivered Panels', 'Estimated Spot length',
        'Delivered Spot length', 'Delivered No.of panels in IDS',
        'Delivered No of panels delivered over 97%'
    ],
    [CAMPAING_PROMISE_TYPES.SE_CLASSIC_VAC]: [        
        'Estimated Panels', 'Delivered Panels'
    ]    
};